import React, { useEffect, useState } from 'react';
import Card from '@/components/common/Card';
import themeJson from './purple-passion.json';
import { Button } from '../../../../../components/ui/button';
import { DownloadIcon } from 'lucide-react';
import domtoimage from 'dom-to-image';
import EChartsReact from "echarts-for-react";

const ScatterChartData = (props) => {
    const { chartData, isLoading, tenorName } = props;
    const [option, setOption] = useState({});
    const [chartLoad, setChartLoad] = useState(false);

    useEffect(() => {
        if (chartData?.length) {

            setChartLoad(true);

            const filteredData = chartData?.map((data) => {
                const keys = Object.keys(data);
                let obj = {}
                keys.forEach((key) => {
                    if (tenorName?.includes(key) || key === "date") {
                        obj[key] = data[key];
                    }
                })
                // debugger
                return obj
            })
            

            const objectWithMostProps = filteredData?.length > 0 && filteredData.reduce((mostProps, current) => {
                return Object.keys(current).length > Object.keys(mostProps).length ? current : mostProps;
            }, filteredData[0]); // Initialize with the first object


            const bondTerms = Object.keys(objectWithMostProps).filter(key => key !== 'date' && key !== 'borderWidth');
            
            const labels = filteredData?.reverse().map(item => item.date);

            // Helper function to parse dates in "dd/MM/yyyy" format
            const parseDate = (dateStr) => {
                const [day, month, year] = dateStr?.split('/').map(Number);
                return new Date(year, month - 1, day);
            };

            // Get the current date and the date 5 months ago from today
            const currentDate = new Date();
            const fiveMonthsAgo = new Date();
            fiveMonthsAgo.setMonth(currentDate.getMonth() - 5);

            // Parse the last date in myDates array and get the date 5 months ago from it
            const lastDateInArray = parseDate(labels[labels?.length - 1]);
            const fiveMonthsAgoFromLastDate = new Date(lastDateInArray);
            fiveMonthsAgoFromLastDate.setMonth(lastDateInArray.getMonth() - 5);

            // Filter the myDates array based on the above criteria
            const filteredDates = labels.length ? labels.filter(dateStr => {
                const date = parseDate(dateStr);
                return (date >= fiveMonthsAgo || date >= fiveMonthsAgoFromLastDate);
            }) : [];

            const preparedData = bondTerms.map(term => {

                return {
                    name: term,
                    type: 'scatter', // or 'scatter' depending on your preference
                    data: chartData.map(item => item[term]),
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 8,
                    itemStyle: {
                        borderColor: '#555'
                    },
                    lineStyle: {
                        width: 3,
                        shadowColor: 'rgba(0,0,0,0.3)',
                        shadowBlur: 10,
                        shadowOffsetY: 8
                    },
                    datasetIndex: 1

                };
            });

            const optionData = {
                tooltip: {
                    trigger: 'item',
                    // axis: 'auto',
                    axisPointer: { type: 'shadow' },
                    confine: true,
                    align: 'center',
                    backgroundColor: '#001F3D',
                    appendToBody: false,
                    textStyle: {
                        fontSize: 12,
                        color: '#FFFFFF',
                    }
                },
                legend: {
                    type: 'scroll',
                    right: 0,
                    top: 0,
                    left: 0,
                },

                xAxis: [{
                    type: 'category',
                    axisTick: { alignWithLabel: true },
                    data: labels
                }],
                // zoom in chart 
                dataZoom: [

                    {
                        type: 'inside',
                        startValue: filteredDates?.length >= 1 ? filteredDates[0] : '',
                        zoomOnMouseWheel: false
                    },
                    {
                        start: 0,
                        bottom: 8,
                        end: 0,
                        width: "85%",
                        left: "8.5%",
                        right: "8.5%",
                    }
                ],
                yAxis: [{
                    type: 'value',
                    position: 'center'
                }],
                grid: {
                    left: '3%',
                    right: '3%',
                    bottom: '10%',
                    containLabel: true
                },
                series: preparedData,
                theme: themeJson.theme
            };

            setOption((prev) => ({ ...prev, ...optionData }));
            setChartLoad(false)
        }
    }, [chartData]);


    const downloadChartAsJPEG = () => {
        chartData.length && domtoimage.toJpeg(document.getElementById('canvaHtml'), { quality: 0.95, backgroundColor: 'white', style: { backgroundColor: 'white', backgroundImage: 'none', margin: '0px' } })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'my-image-name.jpeg';
                link.href = dataUrl;
                link.click();
            });
    }

    return (
        <>
            {chartData?.length ? <Card className="bg-white p-3 md:p-5 ">
                <div className='flex justify-end'>
                    <Button variant="outline" size="sm" className="w-8 h-8 p-0 hover:bg-[#F5F5F5]" onClick={() => downloadChartAsJPEG('echarts-chart2')}>
                        <span><DownloadIcon className='w-4 h-4' /></span>
                    </Button>
                </div>
                {/* <div className="table-wrapper" id='canvaHtml'>
                    {isLoading ? <Loading /> : <ReactEChartsCore
                        key="timeSeriesChart" // Add key prop here
                        className={"echarts-chart2"}
                        echarts={echarts} 
                        style={{ width: '100%', height: '500px' }}
                        option={option}
                        opts={{ renderer: 'svg' }} // Specify SVG renderer here
                    />}
                </div> */}
                <div className="table-wrapper" id='canvaHtml'>
                    {chartData?.length && <EChartsReact
                        key="timeSeriesChart" // Add key prop here
                        className={"echarts-chart2"}
                        // theme={'dark'}
                        notMerge={true}
                        lazyUpdate={chartLoad || isLoading}
                        showLoading={chartLoad || isLoading}
                        style={{ width: '100%', height: '500px' }}
                        option={option}
                        opts={{ renderer: 'svg' }}
                    />}
                </div>
            </Card> : ''}
        </>
    );
}

export default ScatterChartData;



// // Function to parse the date from MM/DD/YYYY format to a Date object
// function parseDates(dateStr) {
//     const [month, day, year] = dateStr.split('/');
//     return new Date(year, month - 1, day);
// }

// // Function to filter dates within the last 5 months
// function filterDates(dates) {
//     const today = new Date();
//     const fiveMonthsAgo = new Date();
//     fiveMonthsAgo.setMonth(today.getMonth() - 5);

//     const filteredDates = dates.filter(dateStr => parseDates(dateStr) >= fiveMonthsAgo);

//     return filteredDates.length > 0 ? filteredDates : dates;
// }

// // Get the filtered or original dates array
// const resultDates = filterDates(labels);
// console.log('resultDates', resultDates);
